import React, { useContext, useEffect, useState } from "react";
import { Card, StatisticCard } from "../components";
import axios from "axios";
import { LoginContext } from "../reactcontext/ReactContext";
import swal from "sweetalert";
import GroupedPayments from "../components/GroupedPayments";
import ChartDiagram from "../components/ChartDiagram";
import { Link, useNavigate } from "react-router-dom";
import { FaUserCheck } from "react-icons/fa";
import { FaUserAltSlash } from "react-icons/fa";
import { FaPassport } from "react-icons/fa";
import { IoDocumentLockSharp } from "react-icons/io5";
import { FaRegIdCard } from "react-icons/fa";
import { FaMoneyBillWave, FaUsers, FaFirstAid } from "react-icons/fa";
import NationalityChart from "../components/NationalityChart";
import PaymentChart from "../components/PaymentChart";

const Dashboard = () => {
  const apiUrl = process.env.REACT_APP_API_URL;

  const [loading, setLoading] = useState(true);
  const { loginInfo } = useContext(LoginContext);
  const [agents, setAgents] = useState([]);
  const [expiredPassports, setExpiredPassports] = useState(0);
  const [passportsDue, setPassportsDue] = useState(0);
  const [expiredVisas, setExpiredVisas] = useState(0);
  const [visasDue, setVisasDue] = useState(0);
  const [needMedicalCount, setNeedMedicalCount] = useState(0);
  const [totalAmountDue, setTotalAmountDue] = useState(0);
  const [currentMonthCollection, setCurrentMonthCollection] = useState(0);
  const [lastMonthCollection, setLastMonthCollection] = useState(0);
  const navigate = useNavigate();
  const [activeXInactive, setActiveXInactive] = useState({
    active: 0,
    inActive: 0,
  });

  useEffect(() => {
    if (!loginInfo.login) {
      navigate("/login");
    }
  }, [loginInfo, navigate]);

  useEffect(() => {
    axios
      .get(`${apiUrl}/employee/getActiveAndInactive`, {
        headers: {
          loginToken: localStorage.getItem("loginToken"),
        },
      })
      .then((res) => {
        setLoading(false);

        setActiveXInactive({
          active: Array.isArray(res.data.activeEmp) ? res.data.activeEmp.length : 0,
          inActive: Array.isArray(res.data.inActiveEmp) ? res.data.inActiveEmp.length : 0,
        });
      })
      .catch((err) => {
        setLoading(false);
        swal({
          icon: "error",
          timerProgressBar: true,
          button: false,
          title: "Error !",
          text: JSON.stringify(err.response?.data?.error),
          timer: 3000,
        });
      });

    axios
      .get(`${apiUrl}/agent`, {
        headers: {
          loginToken: localStorage.getItem("loginToken"),
        },
      })
      .then((res) => {
        setLoading(false);

        setAgents(Array.isArray(res.data) ? res.data : []);
      })
      .catch((err) => {
        setLoading(false);
        swal({
          icon: "error",
          timerProgressBar: true,
          button: false,
          title: "Error !",
          text: JSON.stringify(err.response?.data?.error),
          timer: 3000,
        });
      });

    axios
      .get(`${apiUrl}/employee/passportExpired`, {
        headers: {
          loginToken: localStorage.getItem("loginToken"),
        },
      })
      .then((res) => {
        setExpiredPassports(res.data?.passports?.length);
        setLoading(false);
        console.log(res.data)
      })
      .catch((err) => {
        swal({
          title: "Error",
          icon: "error",
          text: JSON.stringify(err.message),
        });
        setLoading(false);
      });

    axios
      .get(`${apiUrl}/employee/passportExpire`, {
        headers: {
          loginToken: localStorage.getItem("loginToken"),
        },
      })
      .then((res) => {
        console.log();
        setPassportsDue(res.data?.passports?.length);

        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        swal({
          title: "Error",
          icon: "error",
          text: JSON.stringify(err.message),
        });
        setLoading(false);
      });

    axios
      .get(`${apiUrl}/employee/visaExpired`, {
        headers: {
          loginToken: localStorage.getItem("loginToken"),
        },
      })
      .then((res) => {
        setExpiredVisas(res.data?.visas?.length);
        setLoading(false);
      })
      .catch((err) => {
        swal({
          title: "Error",
          icon: "error",
          text: JSON.stringify(err.message),
        });
        setLoading(false);
      });

    axios
      .get(`${apiUrl}/employee/visaExpire`, {
        headers: {
          loginToken: localStorage.getItem("loginToken"),
        },
      })
      .then((res) => {
        console.log();
        setVisasDue(res.data?.visas?.length);

        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        swal({
          title: "Error",
          icon: "error",
          text: JSON.stringify(err.message),
        });
        setLoading(false);
      });

    axios
      .get(`${apiUrl}/employee/medicalList`, {
        headers: {
          loginToken: localStorage.getItem("loginToken"),
        },
      })
      .then((res) => {
        const passports = res.data?.passports || [];
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const DONE_STATUSES = ['Approved', 'Pending', 'Rejected'];
        const count = passports.filter(r => {
          const mcStatus = r.Employee?.Health?.mcStatus;
          if (mcStatus && DONE_STATUSES.includes(mcStatus)) return false;
          const visas = r.Employee?.Visas;
          if (!visas || visas.length === 0) return false;
          const latest = visas.reduce((a, b) =>
            new Date(a.expiryDate) > new Date(b.expiryDate) ? a : b
          );
          if (!latest?.expiryDate) return false;
          const expiry = new Date(latest.expiryDate);
          expiry.setHours(0, 0, 0, 0);
          const daysLeft = Math.ceil((expiry - today) / (1000 * 60 * 60 * 24));
          return daysLeft >= 0 && daysLeft <= 90;
        }).length;
        setNeedMedicalCount(count);
      })
      .catch((err) => {
        console.log("Error fetching need medical count:", err);
      });

    // Fetch total amount due from payments
    axios
      .get(`${apiUrl}/payment/getAllPaymentsWithBalance`, {
        headers: {
          loginToken: localStorage.getItem("loginToken"),
        },
      })
      .then((res) => {
        const payments = Array.isArray(res.data) ? res.data : [];
        const total = payments.reduce((sum, payment) => {
          const balance = parseFloat(payment.balance) || 0;
          return sum + balance;
        }, 0);
        setTotalAmountDue(total);
        setLoading(false);
      })
      .catch((err) => {
        console.log("Error fetching payment balance:", err);
        setLoading(false);
      });
    // Fetch monthly collection amounts
    axios
      .get(`${apiUrl}/payment/getGroupedPayments`, {
        headers: { loginToken: localStorage.getItem("loginToken") },
      })
      .then((res) => {
        const now = new Date();
        const currentMonthName = now.toLocaleString('default', { month: 'long' });
        const currentYear = String(now.getFullYear());
        const lastMonthDate = new Date(now.getFullYear(), now.getMonth() - 1, 1);
        const lastMonthName = lastMonthDate.toLocaleString('default', { month: 'long' });
        const lastMonthYear = String(lastMonthDate.getFullYear());

        const data = res.data || {};
        const currentTotal = data[currentYear]?.months?.[currentMonthName]?.total || 0;
        const lastTotal = data[lastMonthYear]?.months?.[lastMonthName]?.total || 0;
        setCurrentMonthCollection(currentTotal);
        setLastMonthCollection(lastTotal);
      })
      .catch((err) => {
        console.log("Error fetching monthly payments:", err);
      });
  }, []);
  // console.log(expiredPassports,expiredVisas)
  return (
    <div className="w-full bg-gradient-to-br from-gray-50 to-gray-100 min-h-screen rounded-lg gap-6 p-6 lg:p-8 flex items-start flex-col">
      {/* Header Section */}
      <div className="w-full">
        <h1 className="text-3xl lg:text-4xl font-bold text-gray-800">
          Dashboard
        </h1>
        <p className="text-gray-500 mt-2">Welcome back to Rahman Group</p>
      </div>

      <div className="flex flex-col justify-evenly w-full gap-4">
        {/* Top Stats Cards - Priority Metrics */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 w-full">
          <Card title={"Active Profiles"} link={"profile?status=Active"}>
            <StatisticCard
              name={<FaUserCheck fontSize={26} className="text-emerald-500" />}
              value={!loading ? activeXInactive.active : 0}
            />
          </Card>
          <Card title={"Inactive Profiles"} link={"profile?status=Inactive"}>
            <StatisticCard
              name={<FaUserAltSlash fontSize={26} className="text-red-500" />}
              value={!loading ? activeXInactive.inActive : 0}
            />
          </Card>
          <Card title={"Total Amount Due"} link={"payments"}>
            <StatisticCard
              name={<FaMoneyBillWave fontSize={26} className="text-green-500" />}
              value={!loading ? `${totalAmountDue.toLocaleString()}` : "0"}
            />
          </Card>
          <Card title={"Total Agents"} link={"agents"}>
            <StatisticCard
              name={<FaUsers fontSize={26} className="text-blue-500" />}
              value={!loading ? agents.length : 0}
            />
          </Card>
        </div>

        {/* Secondary Stats - Document Status */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 w-full">
          <Card title={"Passports Due"} link={"6_month"}>
            <StatisticCard
              name={<FaPassport fontSize={26} className="text-orange-500" />}
              value={!loading && passportsDue}
            />
          </Card>
          <Card title={"Visas Due"} link={"90_days"}>
            <StatisticCard
              name={<FaRegIdCard fontSize={26} className="text-purple-500" />}
              value={!loading && visasDue}
            />
          </Card>
          <Card title={"Expired Passports"} link={"pass_expired"}>
            <StatisticCard
              name={<FaPassport fontSize={26} className="text-yellow-600" />}
              value={!loading && expiredPassports}
            />
          </Card>
          <Card title={"Expired Visas"} link={"expired"}>
            <StatisticCard
              name={<IoDocumentLockSharp fontSize={26} className="text-red-600" />}
              value={!loading && expiredVisas}
            />
          </Card>
          <Card title={"Medical Need"} link={"medical/need-mc"}>
            <StatisticCard
              name={<FaFirstAid fontSize={26} className="text-teal-600" />}
              value={!loading ? needMedicalCount : 0}
            />
          </Card>
          <Card title={"This Month Collection"} link={"payments"}>
            <StatisticCard
              name={<FaMoneyBillWave fontSize={26} className="text-cyan-500" />}
              value={!loading ? `RM ${currentMonthCollection.toLocaleString()}` : "0"}
            />
          </Card>
          <Card title={"Last Month Collection"} link={"payments"}>
            <StatisticCard
              name={<FaMoneyBillWave fontSize={26} className="text-indigo-500" />}
              value={!loading ? `RM ${lastMonthCollection.toLocaleString()}` : "0"}
            />
          </Card>
        </div>

        {/* Charts Section - Responsive Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 w-full mt-3">
          <div className="w-full bg-white rounded-lg shadow-lg px-4 pt-4 pb-0 hover:shadow-xl transition-shadow overflow-hidden">
            <ChartDiagram agents={agents} />
          </div>
          <div className="w-full bg-white rounded-lg shadow-lg px-4 pt-4 pb-0 hover:shadow-xl transition-shadow overflow-hidden">
            <GroupedPayments />
          </div>
        </div>

        {/* Additional Charts Section */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 w-full mt-3">
          <div className="w-full bg-white rounded-lg shadow-lg px-4 pt-4 pb-0 hover:shadow-xl transition-shadow overflow-hidden">
            <NationalityChart />
          </div>
          <div className="w-full bg-white rounded-lg shadow-lg px-4 pt-4 pb-0 hover:shadow-xl transition-shadow overflow-hidden">
            <PaymentChart />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
